import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { FILE_ICONS } from 'consts/consts';
import { FILE_TYPES, MESSAGE_SENDER, MESSAGE_TYPE } from 'consts/enum';
import { generate6DigitUUID, getFormatedFileSize } from 'helpers/helpers';
import { SendDocumentTemplate } from './sendDocument.template';

const { BOT, AGENT } = MESSAGE_SENDER;

export default class SendDocument {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	getFileType(url) {
		const fileExt = url.lastIndexOf('.') + 1;
		const type = url.substring(fileExt);
		const fileIconType = FILE_TYPES[type] || 'FILE';
		return FILE_ICONS[fileIconType];
	}

	getFileName(url) {
		const fileNameIdx = url.lastIndexOf('/') + 1;
		const file = decodeURIComponent(url.substring(fileNameIdx));
		return file;
	}

	initData(propData = {}) {
		this.data = {};
		const { sender } = propData;
		const { file_size, file_name, alt_text, file_url, message_text, enable_download } = propData.message?.data;
		const { meta_data } = propData;
		const metaData = meta_data && JSON.parse(meta_data);
		const fileName = file_name?.length ? file_name : this.getFileName(file_url);
		const fileSize = !file_size ? metaData?.file_size : file_size;
		const name = fileName?.length > 20 ? `${fileName.substr(0, 20)}...` : fileName;
		this.setter({
			...propData,
			sender,
			fileSize: getFormatedFileSize(fileSize),
			altText: alt_text || 'File',
			fileName: name,
			fileUrl: file_url,
			fileIcon: this.getFileType(file_url),
			messageText: message_text,
			enableDownload: enable_download,
			id: propData.message_id || generate6DigitUUID(),
		});
	}

	initWrapper() {
		const { sender = BOT } = this.data;
		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-msg', `engt-msg-${sender}`, `engt-msg-border-${sender}`, 'engt-msg-document');
		wrapper.innerHTML = SendDocumentTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const { sender = BOT } = this.data;

		this.html = new MessageWrapper({
			...this.data,
			message: MESSAGE_TYPE.FILE,
			innerHTML: this.html.outerHTML,
			download: this.data.enableDownload,
			downloadLink: this.data.fileUrl,
		});
	}

	initEventHandlers() {}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
